import Fse from '../script/Fse';
import Formsoin from '../script/TransCAM/Forms/Formsoin';
import formsoin from '../script/TransCAM/Forms/Formsoin';
export default {
    namespaced: true,

    state() {
        return {
            formsoin: new Formsoin()
        };
    },

    getters: {
        getFormsoin(state) {
            console.log("formsoin");
            return state.formsoin;
        }
    },

    mutations: {
        setFormsoin(state, formsoin) {
            state.formsoin = formsoin;
        },
    },

    actions: {
        setFormsoin({ commit }, formsoin) {
            commit("setFormsoin", formsoin);
        },
        async initFormsoin({ commit, state }) {
            //alert("dans actions FormStore.initFormsoin")

            const formsoin = await Formsoin.initFormsoin();
            commit("setFormsoin", formsoin);
        },

        // ATTENTION : envoie le formsoin du store au backend, ce qui REMPLACE l'instance
        // serveur Formsoin.FormSoin_Instance (et perd ses champs serveur : noadh, datepj,
        // listmtText/parcours...). Passer par initFormsoin d'abord pour partir d'une
        // instance initialisee cote backend. Le flux actif (NewFSE) utilise
        // FSEHandler/enregistrerFse sans body.
        async enregistrerFse({ state }) {
            return await Fse.enregistrerFse(state.formsoin);
        }
    }
};
